import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import type { StatusPackWarning } from '@avisoma/shared';
import { WarningDocumentLink } from './WarningDocumentLink';

const formatCsn = (value: number) => value.toLocaleString('en-US');

function CsnBelowOlderPackLine({ warning }: { warning: StatusPackWarning }) {
  return (
    <>
      Header CSN {formatCsn(warning.headerCsn)} is below an older pack&apos;s header CSN{' '}
      {formatCsn(warning.olderHeaderCsn)} (<WarningDocumentLink documentId={warning.olderDocumentId} />, dated{' '}
      {warning.olderDate}).
    </>
  );
}

/**
 * DR-4456: review flags on the published AD / SB / QEC status pack. The newest
 * pack still wins; a flag asks a human to check it against an older pack.
 */
export function StatusPackWarnings({ warnings }: { warnings?: StatusPackWarning[] }) {
  if (!warnings?.length) return null;

  return (
    <ul className="space-y-2 border-t border-gray-200 pt-4 dark:border-zinc-700">
      {warnings.map((warning, index) => (
        <li
          key={`${warning.code}-${warning.documentId}-${index}`}
          className="flex items-start gap-2 text-sm text-amber-600 dark:text-amber-400"
        >
          <ExclamationTriangleIcon className="mt-0.5 size-3.5 shrink-0" aria-hidden="true" />
          <span>
            <CsnBelowOlderPackLine warning={warning} />
          </span>
        </li>
      ))}
    </ul>
  );
}
